export const POST_REGISTER_REQUEST = "POST_REGISTER_REQUEST";
export const POST_REGISTER_SUCCESS = "POST_REGISTER_SUCCESS";
export const POST_REGISTER_FAIL = "POST_REGISTER_FAIL";

export const POST_LOGIN_REQUEST = "POST_LOGIN_REQUEST";
export const POST_LOGIN_SUCCESS = "POST_LOGIN_SUCCESS";
export const POST_LOGIN_FAIL = "POST_LOGIN_FAIL";

export const GET_LOGIN_GOOGLE_REQUEST = "GET_LOGIN_GOOGLE_REQUEST";
export const GET_LOGIN_GOOGLE_SUCCESS = "GET_LOGIN_GOOGLE_SUCCESS";
export const GET_LOGIN_GOOGLE_FAIL = "GET_LOGIN_GOOGLE_FAIL";

export const GET_LOGIN_FACEBOOK_REQUEST = "GET_LOGIN_FACEBOOK_REQUEST";
export const GET_LOGIN_FACEBOOK_SUCCESS = "GET_LOGIN_FACEBOOK_SUCCESS";
export const GET_LOGIN_FACEBOOK_FAIL = "GET_LOGIN_FACEBOOK_FAIL";

export const PUT_LOGOUT_REQUEST = "PUT_LOGOUT_REQUEST";
export const PUT_LOGOUT_SUCCESS = "PUT_LOGOUT_SUCCESS";
export const PUT_LOGOUT_FAIL = "PUT_LOGOUT_FAIL";